import { render } from "./QuizAnswerButton.vue?vue&type=template&id=57030efa&scoped=true"
import script from "./QuizAnswerButton.vue?vue&type=script&lang=js"
export * from "./QuizAnswerButton.vue?vue&type=script&lang=js"

import "./QuizAnswerButton.vue?vue&type=style&index=0&id=57030efa&lang=scss&scoped=true"

import exportComponent from "/Users/Shared/PLAYLANE/Execution/P1901021/sandpiper/bbud-server/teacher-platform-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57030efa"]])

export default __exports__